<template>
  <img
    ref="imageElement"
    v-bind="$attrs"
    :src="filteredSrc"
  />
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue';

defineOptions({
  name: 'CustomImg',
  inheritAttrs: false,
});

const props = defineProps<{
  src?: string;
}>();

const imageElement = useTemplateRef<HTMLImageElement>('imageElement');

const HTTP_IMAGE_PREFIXES = [
  'http://47.252.74.21:18765/',
  'http://127.0.0.1:18765/',
  'http://localhost:18765/',
];

const IMAGE_PROXY_API_PATH = '/wp-json/sunon-ai/v1/image-proxy';

/**
 * 图片地址的统一过滤入口。
 * 指定 HTTP 图片通过 WordPress 同源接口加载，
 * 避免 HTTPS 页面触发混合内容拦截。
 */
const filterImageSrc = (
  src: string | undefined,
): string | undefined => {
  if (!src) {
    return src;
  }

  const shouldProxy = HTTP_IMAGE_PREFIXES.some((prefix) =>
    src.startsWith(prefix),
  );

  if (!shouldProxy) {
    return src;
  }

  const proxyUrl = new URL(
    IMAGE_PROXY_API_PATH,
    window.location.origin,
  );

  proxyUrl.searchParams.set('uri', src);

  return proxyUrl.toString();
};

const filteredSrc = computed(() =>
  filterImageSrc(props.src),
);

// 组件 ref 无法直接等同于原生元素，因此显式暴露内部 HTMLImageElement。
defineExpose({
  imageElement,
});
</script>